import { render, staticRenderFns } from "./SliderNew.vue?vue&type=template&id=01b4ceb0&scoped=true&"
import script from "./SliderNew.vue?vue&type=script&lang=js&"
export * from "./SliderNew.vue?vue&type=script&lang=js&"
import style0 from "./SliderNew.vue?vue&type=style&index=0&id=01b4ceb0&prod&scoped=true&lang=css&"
import style1 from "./SliderNew.vue?vue&type=style&index=1&id=01b4ceb0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b4ceb0",
  null
  
)

export default component.exports